import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";

export interface TreatmentService {
  id: number,
  code: string,
  name: string,
  display_name: string,
  position: number,
  flags: {
    multi_medicine: boolean
  },
  genders: ['female', 'male'],
  intro: string,
  is_lab: boolean,
  product_groups_enabled: boolean,
  product: {
    count: number
  },
  medication_charge_required: number | boolean,
  visit_price: number | null,
}

export interface ChildService extends TreatmentService {
  parent_id: number,
  visible: number,
  questionnaire_id: number,
  staged_questionnaire_id: number,
}

export interface ParentService extends TreatmentService {
  parent_id: null,
  visible: boolean,
  long_name: "Chlamydia Treatment",
  questionnaire_id: null,
  staged_questionnaire_id: null,
  children: ChildService[],
  has_lab: false,
  supported_states: [
    "UK"
  ],
  has_mailorder: boolean
}

export type CategoriesResponse = ParentService[]

@Injectable({
  providedIn: 'root'
})
export class CategoriesApiService {
	private http = inject(HttpClient);

	private env = inject<PIMSEnvironment>(ENVIRONMENT)

  getCategories() {
    return this.http.get<CategoriesResponse>(`${this.env.constants.API_URL}/products/categories`);
  }
}
